/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Injectable }            from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class UserLogService
 *
 * @brief access to MongoDB user logging data
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class UserLogService {

  constructor(
    private http: HttpClient
  ) {


  }

  /** fetch the root node of this user log */
  root(collection: string) {

    return this.http.get<any>(`/backend/userlogs/${collection}/root`);
  }

  /** fetch the root node of this user log */
  trains(collection: string) {

    return this.http.get<any[]>(`/backend/userlogs/${collection}/trains`);
  }

  /** specifically for AG Grid style expansion of children by their "group key" */
  groupExpand(collection: string, groupKeys: string[]) {

    /*
     * in this mode we are given a random set of ids which are presumed to have children,
     * the backend will have to expand them regardless of where they are in the tree data,
     * they are just a set of random parent nodes that must now be expanded.
     *
     */

    return this.http.post( `/backend/userlogs/expand/groupkeys`, {collection, groupKeys});
  }

  /** fetch the children but as a deferred promise, for usue with TreeModel */
  childrenPromise(collection: string, parent: string) {

    return this.http.get<any[]>(`/backend/userlogs/${collection}/${btoa(parent)}/children`).toPromise();
  }

  /** fetch the authorities of these trains that intersect this time point */
  authorities(collection: string, time: number, trains: string[]) {

    const url     = `/backend/userlogs/${collection}/authorities`;
    const headers = {
      'content-type': 'application/json'
    }

    return this.http.post<any[]>(url, {time, trains},{headers});
  }

  /** fetch anything small enough to cache up front */
  preload(collection: string) {

    return this.http.get<any[]>(`/backend/userlogs/${collection}/preload`);
  }
}
